import Vue from 'vue'
import VueRouter from 'vue-router'

// Views
import System from "../components/aquincum/System.vue"
import LoginComponent from "../views/Login.vue"

import MainContent from '../components/MainContent.vue'
import ChangePassword from '../views/ChangePassword/ChangePassword.vue'

// Vendor
import Vendor from '../views/Vendor/Vendor.vue'
import VendorEdit from '../views/Vendor/VendorEdit.vue'

// Vendor Project
import VendorProject from '../views/VendorProject/VendorProject.vue'
import VendorProjectEdit from '../views/VendorProject/VendorProjectEdit.vue'

// Project
import Project from '../views/Project/Project.vue'
import ProjectEdit from '../views/Project/ProjectEdit.vue'

// Product
import Product from '../views/Product/Product.vue'
import ProductEdit from '../views/Product/ProductEdit.vue'

import ProductCategory from '../views/Product/ProductCategory/ProductCategory.vue'
import ProductCategoryEdit from '../views/Product/ProductCategory/ProductCategoryEdit.vue'

// Sample Stock
import SampleStock from '../views/SampleStock/SampleStock.vue'
import SampleStockEdit from '../views/SampleStock/SampleStockEdit.vue'

// User
import User from '../views/User/User.vue'
import UserEdit from '../views/User/UserEdit.vue'

import RolePermission from '../views/User/RolePermission/RolePermission.vue'
import RolePermissionEdit from '../views/User/RolePermission/RolePermissionEdit.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: {
        name: "system"
    }
  },
  {
    path: "/login",
    name: "login",
    component: LoginComponent
  },
  {
    path: "/system",
    name: "system",
    component: System,
    children: [
      { path: 'dashboard', name: "main", component: MainContent },
      { path: 'changepassword', name: "changepassword", component: ChangePassword },

      { path: 'vendor', name: "vendor.index", component: Vendor, props: { pageType: 'listing' } },
      { path: 'vendor/create', name: "vendor.create", component: VendorEdit, props: { pageType: 'create' } },
      { path: 'vendor/edit/:id', name: "vendor.edit", component: VendorEdit, props: { pageType: 'edit' } },
      { path: 'vendor/view/:id', name: "vendor.view", component: VendorEdit, props: { pageType: 'view' } },

      { path: 'vendorproject/:id?', name: "vendorproject.index", component: VendorProject, props: { pageType: 'listing' } },
      { path: 'vendorproject/create', name: "vendorproject.create", component: VendorProjectEdit, props: { pageType: 'create' } },
      { path: 'vendorproject/edit/:id', name: "vendorproject.edit", component: VendorProjectEdit, props: { pageType: 'edit' } },
      { path: 'vendorproject/view/:id', name: "vendorproject.view", component: VendorProjectEdit, props: { pageType: 'view' } },

      { path: 'vendorproject/project', name: "project.index", component: Project, props: { pageType: 'listing' } },
      { path: 'vendorproject/project/create', name: "project.create", component: ProjectEdit, props: { pageType: 'create' } },
      { path: 'vendorproject/project/edit/:id', name: "project.edit", component: ProjectEdit, props: { pageType: 'edit' } },
      { path: 'vendorproject/project/view/:id', name: "project.view", component: ProjectEdit, props: { pageType: 'view' } },

      { path: 'product/:id?', name: "product.index", component: Product, props: { pageType: 'listing' } },
      { path: 'product/create', name: "product.create", component: ProductEdit, props: { pageType: 'create' } },
      { path: 'product/edit/:id', name: "product.edit", component: ProductEdit, props: { pageType: 'edit' } },
      { path: 'product/view/:id', name: "product.view", component: ProductEdit, props: { pageType: 'view' } },

      { path: 'product/category', name: "product.category.index", component: ProductCategory, props: { pageType: 'listing' } },
      { path: 'product/category/create', name: "product.category.create", component: ProductCategoryEdit, props: { pageType: 'create' } },
      { path: 'product/category/edit/:id', name: "product.category.edit", component: ProductCategoryEdit, props: { pageType: 'edit' } },
      { path: 'product/category/view/:id', name: "product.category.view", component: ProductCategoryEdit, props: { pageType: 'view' } },

      { path: 'samplestock', name: "samplestock.index", component: SampleStock, props: { pageType: 'listing' } },
      { path: 'samplestock/create', name: "samplestock.create", component: SampleStockEdit, props: { pageType: 'create' } },
      { path: 'samplestock/edit/:id', name: "samplestock.edit", component: SampleStockEdit, props: { pageType: 'edit' } },
      { path: 'samplestock/view/:id', name: "samplestock.view", component: SampleStockEdit, props: { pageType: 'view' } },

      { path: 'user', name: "user.index", component: User, props: { pageType: 'listing' } },
      { path: 'user/create', name: "user.create", component: UserEdit, props: { pageType: 'create' } },
      { path: 'user/edit/:id', name: "user.edit", component: UserEdit, props: { pageType: 'edit' } },
      { path: 'user/view/:id', name: "user.view", component: UserEdit, props: { pageType: 'view' } },

      { path: 'user/role_permssion', name: "user.rolePermission.index", component: RolePermission, props: { pageType: 'listing' } },
      { path: 'user/role_permssion/create', name: "user.rolePermission.create", component: RolePermissionEdit, props: { pageType: 'create' } },
      { path: 'user/role_permssion/edit/:id', name: "user.rolePermission.edit", component: RolePermissionEdit, props: { pageType: 'edit' } },
      { path: 'user/role_permssion/view/:id', name: "user.rolePermission.view", component: RolePermissionEdit, props: { pageType: 'view' } },
      
    ]
  },
  { 
    path: "*", 
    redirect: {
        name: "system"
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
})

export default router
